
<script setup>

  import { PhotoIcon, PlusCircleIcon } from '@heroicons/vue/24/outline';

  import { parseImageName } from '../utils.js';

  const props = defineProps( { name: String, selection: String } );

</script>

<template>

  <button type="button" class="relative bg-neutral-600">
  
    <div class="absolute inset-0 bg-cover bg-center opacity-10"

      :style="{ backgroundImage: `url( '${ selection }' )` }" />

    <div class="absolute inset-0 p-6 text-white text-left">

      <div class="uppercase">Choose {{ name }}</div>

      <div class="truncate text-xs" v-if="selection">({{ parseImageName( selection ) }})</div>

    </div>

    <div class="absolute inset-0 flex items-center justify-center h-full text-white">

      <PhotoIcon class="w-16 opacity-20" />

    </div>
  
    <div class="absolute inset-0 flex items-end justify-end h-full">

      <div class="m-2 p-2 bg-white/75">

        <PlusCircleIcon class="w-8" />

      </div>

    </div>

  </button>

</template>
